import React, { InputHTMLAttributes } from 'react';

interface AuthInputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
}

export const AuthInput: React.FC<AuthInputProps> = ({ label, className, ...props }) => {
    return (
        <div className="auth-input-group">
            <input
                className={`auth-input ${className || ''}`}
                {...props}
            />
            {label && <label className="auth-label">{label}</label>}
        </div>
    );
};
